
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { Watch } from 'vue-property-decorator';

import CommonTitle from './components/commonTitle.vue';

@Component({
  components: { CommonTitle }
})
export default class ProductCenter extends Vue {
  activeName: string = '投建营-OP';
  tabSystemConfigList: Array<{ [key: string]: any }> = [];

  @Getter productEvns: any;
  @Action("getAllProductEvn") getAllProductEvn: Function;

  created() {
    this.getAllProductEvn({onlyEnabled: true, limitNum: 4});
  }

  @Watch('productEvns', { deep: true })
  @Watch('activeName')
  handleTabSystemConfigList() {
    const { infos } = this.productEvns as any;
    if (Array.isArray(infos)) {
      const filterValue = infos.filter(
        (item: any) => item.Title === this.activeName
      ).flatMap((item: any) => item.children);
      this.tabSystemConfigList = (filterValue && filterValue) || [];
    } else {
      this.tabSystemConfigList = [];
    }
  }

  experience(url: string) {
    window.open(url);
  }
}
